import React from "react";
import PropTypes from "prop-types";
import {useTranslation} from "react-i18next";
import StatusDropdownMenu from "features/incidents/IncidentsTable/StatusDropdownMenu";
import PriorityScore from "features/incidents/PriorityScore/PriorityScore";
import Chip from "components/Chip";

const StatusHeaderBar = ({drawer = false, incident}) => {
  const {t} = useTranslation();
  const hasScore = !!incident.scores?.global;

  const status = drawer ? (
    <Chip
      readOnly
      truncateText={hasScore}
      tooltipText={incident.status}
      tooltipPlacement="bottom">
      {incident.status}
    </Chip>
  ) : (
    <StatusDropdownMenu
      incident={incident}
      chipProps={{small: false}}
      menuPlacement="bottom-left"
    />
  );

  return (
    <div
      style={{
        display: "flex",
        alignItems: "baseline",
        gap: drawer ? "20px" : "10px"
      }}>
      <div>
        <PriorityScore
          readOnly={drawer}
          small={drawer}
          showLabel={drawer}
          {...{incident}}
        />
      </div>
      <div>
        {drawer && (
          <span className="mr-1">
            {t("incidentDetail.statusHeader.status")}
          </span>
        )}
        {status}
      </div>
    </div>
  );
};

export default StatusHeaderBar;

StatusHeaderBar.propTypes = {
  /**
   * If true, a readOnly and smaller version of the components will display
   *
   * @defaultValue false
   */
  drawer: PropTypes.bool,
  /**
   * Option to pass in a className to the parent component
   */
  className: PropTypes.string,
  /**
   * Incident object
   */
  incident: PropTypes.object.isRequired
};
